import { appActionArgumentKey } from './appAction/appActionArgumentKey.js';
import { appActionArgumentRequired } from './appAction/appActionArgumentRequired.js';
import { appActionArgumentsList } from './appAction/appActionArgumentsList.js';
import { appActionArgumentType } from './appAction/appActionArgumentType.js';
import { appActionMethod } from './appAction/appActionMethod.js';
import { appActionModel } from './appAction/appActionModel.js';
import { appActionName } from './appAction/appActionName.js';
import { appActionOperation } from './appAction/appActionOperation.js';
import { appActionPresentationResponseMapping } from './appAction/appActionPresentationResponseMapping.js';
import { appActionPresentationSummaryMapper } from './appAction/appActionPresentationSummaryMapper.js';
import { appActionPresentationSingleItem } from './appAction/appActionPresentationSingleItem.js';
import { appActionSlug } from './appAction/appActionSlug.js';
import { appActionsList } from './appAction/appActionsList.js';
import { appActionPath } from './appAction/appActionPath.js';

/**
 * Event Schema Structure
 *
 * Each event in this array follows a specific schema with the following properties:
 *
 * 1. key - Unique identifier for the event
 * 2. type - Type of change (see ai_suggestion.sql for enum values)
 * 3. label - User-friendly label for the event
 * 4. shouldRun - Function that determines if the event should be triggered based on changes
 * 5. context - Array of values to be injected into mapContext
 * 6. mapContext - Function that formats and passes only relevant values for the AI prompt
 * 7. prompt - Name of the AI prompt (should be under api/services/ai/prompts/execAppEvents)
 * 8. handler - Optional function for manual event handling
 *    - If defined, the event won't be sent to AI (no need for context, mapContext, and prompt)
 *    - Should return: { success: boolean, data: { needsSuggestion: boolean, suggestedValue?: string } }
 */

export const activeAppSchemas = {
  events: [
    // App
    appActionsList,

    // App Actions
    appActionName, //
    appActionSlug,
    appActionModel,
    appActionOperation,
    appActionArgumentsList,
    appActionMethod,
    appActionPath,
    appActionArgumentRequired,
    appActionArgumentKey,
    appActionArgumentType,
    appActionPresentationResponseMapping,
    appActionPresentationSummaryMapper,
    appActionPresentationSingleItem
  ]
};

// todo make this not an index file.
